import { Box, Chip } from '@mui/material';

export type FilterChipProps = {
  openFilterDrawer: () => void;
  name?: string;
  value: React.ReactNode;
  reset: () => void;
  active: boolean;
};

const FilterChip = ({
  openFilterDrawer,
  name,
  value,
  reset,
  active,
}: FilterChipProps) => {
  return (
    <Chip
      color="secondary"
      variant={active ? 'filled' : 'outlined'}
      onDelete={active ? reset : undefined}
      onClick={openFilterDrawer}
      label={
        <Box display="flex" flexDirection="row">
          <Box fontWeight="bold">{name}</Box>
          <Box display="flex">
            {name && value && <Box sx={{ mx: 0.35 }}>|</Box>}
            <Box>{value}</Box>
          </Box>
        </Box>
      }
      size="small"
      sx={{ boxShadow: 1, transition: 'all 0.8s' }}
      data-testid="FilterChip"
    />
  );
};

export default FilterChip;
